module.exports = __webpack_public_path__ + "static/media/selfie-correct.0be88af6.png";